import { render, staticRenderFns } from "./InvoicesNew.vue?vue&type=template&id=a7257968&"
import script from "./InvoicesNew.vue?vue&type=script&lang=js&"
export * from "./InvoicesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports